import axios from "axios";
import { AUTH_TOKEN, REACT_APP_API, REACT_APP_PAM_API } from "../constants";

// Single sign-on providers (OpenID Connect, GitHub) for the console, per tenant.
// Backend: internal/pam/handler/instances/sso.go + internal/sso. Every call is
// administrator-only (403 {error: "administrator role required"}); the
// organisation comes from the session. tenantId is the did.tenants id — the
// same value as DOMAIN_ID() (users' domain_id is their tenant id).
//
// Each helper resolves to the response body and rejects with the axios error;
// use ssoError(err) for the message to show.
const headers = () => ({
  headers: { "X-Authorization": AUTH_TOKEN(), withCredentials: true },
});

const post = (path, payload = {}) =>
  axios.post(`${REACT_APP_PAM_API}/sso/${path}`, payload, headers()).then((res) => res?.data);

// body: { tenantId } (0 = every tenant of the organisation)
// → { providers: [{ id, tenantId, kind, name, issuer?, clientId, scopes, emailClaim,
//                   requireEmailVerified, allowedDomains, githubOrg?, enabled,
//                   hasSecret, clientSecret?: "********", createdAt, updatedAt }] }
export const listSsoProviders = (tenantId) => post("listProviders", { tenantId });

// body: { id?, tenantId, kind: "github"|"oidc", name, issuer, clientId, clientSecret,
//         scopes[], emailClaim, requireEmailVerified, allowedDomains[], githubOrg, disabled }
// No id creates (clientSecret required); with id replaces — a clientSecret of ""
// or "********" keeps the stored secret.
// 200 → { provider }   400 → { error }   404 → { error: "no such provider" }
export const saveSsoProvider = (body) => post("saveProvider", body);

// body: { id } → { status: "deleted" }
export const deleteSsoProvider = (id) => post("deleteProvider", { id });

// The callback every provider must have registered. The backend builds it from
// its SSO_CALLBACK_URL env var (internal/sso/flow.go configFromEnv), not from
// the request, so the console cannot read it — but the public SSO routes are
// mounted at /authentication/sso on the same service REACT_APP_API_URL points
// at (cmd/authnull-service/routes.go), so this is what SSO_CALLBACK_URL should
// be set to on a standard deployment.
export const ssoCallbackUrl = () => {
  const base = String(REACT_APP_API || window.location.origin || "").replace(/\/+$/, "");
  return `${base}/authentication/sso/callback`;
};

export const ssoError = (err, fallback = "Request failed") => {
  const data = err?.response?.data;
  if (data && typeof data.error === "string" && data.error) return data.error;
  if (err?.response?.status === 403) return "Administrator role required";
  if (err?.response?.status === 401) return "Your session has expired — sign in again";
  return err?.message || fallback;
};
